<template>
	<div>
		<bw-table
			aria-label="data-table"
			:headers="headers"
			:items="users"
			showColumnSelect
			showDateFilter="created_at"
		>
			<!-- keep the slot -->
			<!-- TODO: Add color to status -->
			<template v-slot:item.email="{ item: message }">
				<a :href="`mailto:${message.email}`">{{ message.email }}</a>
			</template>
			<template v-slot:item.actions="{ item: message }">
				<v-btn color="secondary" depressed small @click="viewUser(message)">
					View Message
				</v-btn>
			</template>
			<template v-slot:moreActions="{selectedRows}">
				<!-- Mass Edit / Actions for selected rows -->

				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							class="rounded-lg"
							color="grey lighten-3"
							depressed
							:small="$vuetify.breakpoint.smAndDown"
							v-bind="attrs"
							v-on="on"
						>
							<span v-if="$vuetify.breakpoint.smAndUp">
								Action
								<v-icon right>mdi-chevron-down</v-icon>
							</span>
						</v-btn>
					</template>
						<v-list>
							<v-list-item @click="showInviteMsg(selectedRows)">
								<v-icon
									v-if="$vuetify.breakpoint.mdAndUp || $vuetify.breakpoint.xsOnly"
									:class="{
										'me-2': $vuetify.breakpoint.smAndUp,
										'ms-n1': $vuetify.breakpoint.smAndUp
									}"
								>mdi-mail-outline</v-icon>
								Email Invite
							</v-list-item>
						</v-list>
				</v-menu>

			</template>
		</bw-table>

		<create-message
			:showDialog="showDialog"
			:recipients="newMessage.recipients"
			:users="[]"
			:new-message="newMessage"
			@resetMsg="resetMsg"
		></create-message>
	</div>
</template>

<script>
export default {
	name: 'ListUsers',
	props: {
		usersData: {
			type: Array,
			default: () => []
		},
		statuses: {
			type: Array,
			default: () => []
		},
		partner: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			// From here or passed from blade file to props
			headers: [
				{
					align: 'start',
					mandatory: true,
					text: 'Name',
					value: 'name'
				},
				{
					align: 'start',
					selected: true,
					text: 'Email',
					value: 'email'
				},
				{
					align: 'start',
					filterOn: 'roleName',
					selected: true,
					text: 'Role',
					value: 'roleName',
					width: 'auto'
				},
				{
					align: 'center',
					selected: true,
					sortable: false,
					text: 'Created',
					value: 'created_at',
					width: '15%'
				},
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Actions',
					value: 'actions',
					width: '1%'
				}
			],
			users: this.usersData,
			newMessage:{},
			showDialog:false
		};
	},
	computed: {
		avatarSize() {
			if (this.$vuetify.breakpoint.xsOnly) return 36;
			if (this.$vuetify.breakpoint.smOnly) return 40;
			if (this.$vuetify.breakpoint.mdOnly) return 44;
			return 48;
		}
	},
	created() {},
	mounted() {
		this.resetMsg();
	},
	methods: {
		viewUser(message) {
			window.location.href = `/partner-portal/${this.partner.id}/users/edit-message/${message.id}`;
		},
		showInviteMsg(selectedRows) {
			this.newMessage.recipients = selectedRows;
			this.newMessage.subject = 'You have been invited to join ' + this.partner.name + '\'s network.';
			this.newMessage.message = "You have been invited to join " + this.partner.name + "'s network.<br>Click the link below it get started.<br>{{newInviteUrl}}";
			this.showDialog = true;
		},
		resetMsg() {
			this.newMessage = {recipients: [], disableRecipients:true, canTest:true};
		}
	}
};
</script>

<style lang="scss" scoped></style>
